// src/pages/CookiesPolicy.jsx
import React from "react";

const CookiesPolicy = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Política de Cookies</h1>
      <p className="text-secondary">
        QRBenefits utiliza cookies mínimas para mejorar la experiencia del usuario.
      </p>

      <h5 className="fw-bold mt-4">¿Qué son las cookies?</h5>
      <p>Son pequeños archivos que ayudan a recordar tus preferencias.</p>

      <h5 className="fw-bold mt-4">¿Qué cookies usamos?</h5>
      <p>Cookies básicas de sesión para mantener tu login activo.</p>
    </div>
  );
};

export default CookiesPolicy;
